<template>
  <Form ref="peopleForm" :model="formData">
    <Row :gutter="32">
      <Col span="12">
        <FormItem :label="$t('people.chinese_name')" prop="fullname_cn">
          <Input v-model="formData.fullname_cn"></Input>
        </FormItem>
      </Col>
      <Col span="12">
        <FormItem :label="$t('people.english_name')" prop="fullname_en">
          <Input v-model="formData.fullname_en"></Input>
        </FormItem>
      </Col>
    </Row>
    <Row :gutter="32">
      <Col span="12">
        <FormItem :label="$t('people.department')" prop="department_id">
          <DepartmentSelect v-model="formData.department_id"></DepartmentSelect>
        </FormItem>
      </Col>
      <Col span="12">
        <FormItem :label="$t('people.gender')" prop="gender">
          <Select v-model="formData.gender">
            <Option value="Female">{{ $t('female') }}</Option>
            <Option value="Male">{{ $t('male') }}</Option>
          </Select>
        </FormItem>
      </Col>
    </Row>
    <Row :gutter="32">
      <Col span="12">
        <FormItem :label="$t('people.email')" prop="email">
          <Input v-model="formData.email"></Input>
        </FormItem>
      </Col>
      <Col span="12">
        <FormItem :label="$t('people.mobile')" prop="primary_phone_number">
          <Input v-model="formData.primary_phone_number"></Input>
        </FormItem>
      </Col>
    </Row>
    <Row :gutter="32">
      <Col span="12">
        <FormItem :label="$t('people.country')" prop="country">
          <CountrySelect v-model="formData.country"></CountrySelect>
        </FormItem>
      </Col>
      <Col span="12">
        <FormItem :label="$t('people.birthday')" prop="birthday">
          <DatePicker v-model="formData.birthday" type="date" format="yyyy-MM-dd"></DatePicker>
        </FormItem>
      </Col>
    </Row>
    <Divider>{{ $t('people.identities') }}</Divider>
    <Row :gutter="32">
      <Col span="12">
        <FormItem :label="$t('people.erp_id')" prop="erp_id">
          <Input v-model="formData.erp_id"></Input>
        </FormItem>
      </Col>
      <Col span="12">
        <FormItem :label="$t('people.erp_people_id')" prop="erp_people_id">
          <Input v-model="formData.erp_people_id"></Input>
        </FormItem>
      </Col>
    </Row>
    <Row :gutter="32">
      <Col span="12">
        <FormItem :label="$t('people.dingtalk_id')" prop="dingtalk_id">
          <Input v-model="formData.dingtalk_id"></Input>
        </FormItem>
      </Col>
    </Row>
    <Row :gutter="32">
      <Col span="12">
        <FormItem :label="$t('people.uuid')" prop="uuid">
          <Input v-model="formData.uuid" disabled></Input>
        </FormItem>
      </Col>
      <Col span="12">
        <FormItem :label="$t('people.userid')" prop="user_id">
          <Input :value="formData.user ? formData.user.id : ''" disabled></Input>
        </FormItem>
      </Col>
    </Row>
    <div class="text-align-right">
      <Button type="primary" @click="handleSave" :loading="saving">{{ $t('save') }}</Button>
    </div>
  </Form>
</template>

<script>
import moment from 'moment'
import DepartmentSelect from './department-select'
import { CountrySelect } from '@/components/nexpcb'
import { mapActions } from 'vuex'
export default {
  name: 'PeopleForm',
  components: {
    DepartmentSelect,
    CountrySelect
  },
  props: {
    people: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      saving: false,
      formData: {
        fullname_cn: '',
        fullname_en: ''
      }
    }
  },
  methods: {
    ...mapActions(['updatePeople', 'createPeople']),
    setData (data) {
      this.$refs['peopleForm'].resetFields()
      this.formData = _.cloneDeep(data)
    },
    handleSave () {
      this.saving = true
      this.formData.birthday = this.formData.birthday ? moment(this.formData.birthday).format('YYYY-MM-DD') : ''
      // Update
      if (this.formData.id) {
        this.updatePeople({ id: this.formData.id, payload: this.formData }).then(() => {
          this.$emit('save')
        }).finally(() => {
          this.saving = false
        })
      } else {
        this.createPeople(this.formData)
          .then((resp) => {
            this.$router.push({ name: 'menu.people.detail', params: { id: resp.data.id } })
          })
          .finally(() => {
            this.saving = false
          })
      }
    }
  },
  watch: {
    people: {
      handler(val) {
        this.setData(val)
      }
    }
  }
}
</script>
